import _objectSpread from "/Users/jfriend/code/scaletoy/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import { transpose, altToAcc, accToAlt, note } from '@tonaljs/core';
import { transposeFifths } from '@tonaljs/note';
import { get } from '@tonaljs/roman-numeral';

var mapToScale = function mapToScale(scale) {
  return function (symbols) {
    var sep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    return symbols.map(function (symbol, index) {
      return symbol !== "-" ? scale[index] + sep + symbol : "";
    });
  };
};

function keyScale(gradesLiteral, chordsLiteral, hfLiteral, chordScalesLiteral) {
  return function (tonic) {
    var grades = gradesLiteral.split(" ");
    var intervals = grades.map(function (gr) {
      return get(gr).interval || "";
    });
    var scale = intervals.map(function (interval) {
      return transpose(tonic, interval);
    });
    var map = mapToScale(scale);
    return {
      tonic: tonic,
      grades: grades,
      intervals: intervals,
      scale: scale,
      chords: map(chordsLiteral.split(" ")),
      chordsHarmonicFunction: hfLiteral.split(" "),
      chordScales: map(chordScalesLiteral.split(","), " ")
    };
  };
}

var distInFifths = function distInFifths(from, to) {
  var f = note(from);
  var t = note(to);
  return f.empty || t.empty ? 0 : t.coord[0] - f.coord[0];
};

var MajorScale = keyScale("I II III IV V VI VII", "maj7 m7 m7 maj7 7 m7 m7b5", "T SD T SD D T D", "major,dorian,phrygian,lydian,mixolydian,minor,locrian");
var NaturalScale = keyScale("I II bIII IV V bVI bVII", "m7 m7b5 maj7 m7 m7 maj7 7", "T SD T SD D SD SD", "minor,locrian,major,dorian,phrygian,lydian,mixolydian");
var HarmonicScale = keyScale("I II bIII IV V bVI VII", "mmaj7 m7b5 +maj7 m7 7 maj7 mo7", "T SD T SD D SD D", "harmonic minor,locrian 6,major augmented,lydian diminished,phrygian dominant,lydian #9,ultralocrian");
var MelodicScale = keyScale("I II bIII IV V VI VII", "m6 m7 +maj7 7 7 m7b5 m7b5", "T SD T SD D - -", "melodic minor,dorian b2,lydian augmented,lydian dominant,mixolydian b6,locrian #2,altered");
/**
 * Get a major key properties in a given tonic
 * @param tonic
 */

function majorKey(tonic) {
  var keyScale = MajorScale(tonic);
  var alteration = distInFifths("C", tonic);
  var map = mapToScale(keyScale.scale);
  return _objectSpread({}, keyScale, {
    type: "major",
    minorRelative: transpose(tonic, "-3m"),
    alteration: alteration,
    keySignature: altToAcc(alteration),
    secondaryDominants: map("- VI7 VII7 I7 II7 III7 -".split(" ")),
    secondaryDominantsMinorRelative: map("- IIIm7b5 IV#m7 Vm7 VIm7 VIIm7b5 -".split(" ")),
    substituteDominants: map("- bIII7 IV7 bV7 bVI7 bVII7 -".split(" ")),
    substituteDominantsMinorRelative: map("- IIIm7 Im7 IIbm7 VIm7 IVm7 -".split(" "))
  });
}
/**
 * Get minor key properties in a given tonic
 * @param tonic
 */


function minorKey(tonic) {
  var alteration = distInFifths("C", tonic) - 3;
  return {
    type: "minor",
    tonic: tonic,
    relativeMajor: transpose(tonic, "3m"),
    alteration: alteration,
    keySignature: altToAcc(alteration),
    natural: NaturalScale(tonic),
    harmonic: HarmonicScale(tonic),
    melodic: MelodicScale(tonic)
  };
}
/**
 * Given a key signature, returns the tonic of the major key
 * @param sigature
 * @example
 * majorTonicFromKeySignature('###') // => 'A'
 */


function majorTonicFromKeySignature(sig) {
  if (typeof sig === "number") {
    return transposeFifths("C", sig);
  } else if (typeof sig === "string" && /^b+|#+$/.test(sig)) {
    return transposeFifths("C", accToAlt(sig));
  }

  return null;
}

var index = {
  majorKey: majorKey,
  majorTonicFromKeySignature: majorTonicFromKeySignature,
  minorKey: minorKey
};
export default index;
export { majorKey, majorTonicFromKeySignature, minorKey };